import { useTranslation } from "react-i18next";

import { IconFileAttachment02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

export default function StockHeader() {
  const { t } = useTranslation();

  const moduleName = localStorage.getItem("module");

  const breadcrumbs = [
    {
      icon: <IconFileAttachment02 fill="dark" size="20" />,
    },
    {
      label:
        moduleName === "ITS"
          ? t("SIDEBAR.IT_INVENTORY.HARDWARE_INVENTORY")
          : t("SIDEBAR.INVENTORY.STOCK"),
    },
  ];

  const headerText = {
    header:
      moduleName === "ITS"
        ? t("SIDEBAR.IT_INVENTORY.HARDWARE_INVENTORY")
        : t("SIDEBAR.INVENTORY.STOCK"),
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
